/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Go_HomeInputs */



/**
* | output |
* | --- |
* | "Go home" |
*
* @param {Error_Go_HomeInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const error_go_home = /** @type {((inputs?: Error_Go_HomeInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Go_HomeInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Zur Startseite")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Accueil")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("回到首页")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("回到首頁")
	if (locale === "ko") return /** @type {LocalizedString} */ ("홈으로")
	return /** @type {LocalizedString} */ ("Go home")
});